import styled from 'styled-components';
import { colors } from '../utils/colors';

type Props = {
    steps: number;
    currentStep: number;
    demoMode: boolean;
};

export const defaultProgressDotsStyle = {
    color: colors.blue700,
};

const Circle = styled.svg<{ $active: boolean; $completed: boolean }>`
    height: ${({ $active }) => ($active ? '14px' : '10px')};
    width: ${({ $active }) => ($active ? '14px' : '10px')};

    circle {
        fill: ${(props) => props.theme.progressDots.color};
        opacity: ${({ $completed }) => ($completed ? '1' : '0.5')};
    }
`;

const ProgressDotsContainer = styled.div<{ $demoMode: boolean }>`
    display: flex;
    align-items: center;
    gap: 3px;
    padding-top: ${({ $demoMode }) => ($demoMode ? '12px' : '0px')};
    padding-bottom: ${({ $demoMode }) => ($demoMode ? '12px' : '0px')};
`;

export const ProgressDots = ({ steps, currentStep, demoMode }: Props) => {
    return (
        <ProgressDotsContainer $demoMode={demoMode} aria-hidden>
            {new Array(steps).fill('').map((_, index) => (
                <Circle
                    key={index}
                    $active={currentStep === index}
                    $completed={currentStep >= index}
                    viewBox="0 0 10 10"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <circle cx="5" cy="5" r="5" />
                </Circle>
            ))}
        </ProgressDotsContainer>
    );
};
